module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii01NDU2LjcwNyAtMTYxNDIuNjE5IDE0Ni45NDggMTc1LjExOSI+CiAgPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTU5MjYgLTE2NDAyKSI+CiAgICA8ZWxsaXBzZSBzdHlsZT0iZmlsbDojNDg2MTcxOyIgY3g9IjQ3LjE3NCIgY3k9IjQ3LjE3MiIgcng9IjQ3LjE3NCIgcnk9IjQ3LjE3MiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNDk1LjU5MyAyNTkuMzgxKSIvPgogICAgPHBhdGggc3R5bGU9ImZpbGw6IzQ4NjE3MTsiIGQ9Ik0yNDUuMywyMTEuMTcxYTczLjQ3NCw3My40NzQsMCwwLDEsMTQ2Ljk0OCwwIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyMjMuOTk0IDIyMy4zMjkpIi8+CiAgPC9nPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/placeholder_user.svg
// module id = bTcC
// module chunks = 13